import { CustomImage } from '@app/components/various/CustomImage';
import { cn } from '@app/utils/cn';
import { Picture } from '@typings';
import { Link } from 'react-router-dom';

import { VariantLabel } from './VariantLabel';

interface Props {
  isActive: boolean;
  imageSize: string;
  aspectRatio: number;
  onClick?: VoidFunction;
  linkTarget: string;
  image: Picture;
  label?: string;
  shouldReplacePath?: boolean;
}

export const VariantCard = ({
  isActive,
  image,
  linkTarget,
  aspectRatio,
  onClick,
  label,
  children,
  shouldReplacePath = false,
}: React.WithOptionalChildren<Props>) => {
  return (
    <li key={image.variantId}>
      <div
        className={cn(
          'group/variant-card relative -m-0.5 h-full w-[5.625rem] overflow-hidden rounded-small border border-transparent p-2 pt-3 transition-colors hover:border-neutral-40 [&:has(a:focus-visible)]:focus-input-outline',
          {
            'bg-neutral-96': isActive,
            'border-neutral-90': !isActive,
          },
        )}
      >
        {isActive && (
          <div className="absolute left-0 right-0 top-0 h-0.5 bg-neutral-20 transition-colors group-hover/variant-card:bg-neutral-40" />
        )}
        <Link to={linkTarget} className="focus-visible:outline-none" onClick={onClick} replace={shouldReplacePath}>
          <CustomImage aspectRatio={aspectRatio} src={image.src} placeholderClassName="mb-1" />
          <VariantLabel>{label}</VariantLabel>
        </Link>
        {children}
      </div>
    </li>
  );
};
